import { useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

import { useConfigContext } from "shared/contexts/ConfigContext";
import { useKeyBinding } from "shared/hooks";
import { isMac } from "shared/utils";

import Button from "features/components/Button";
import Dialog from "features/components/Dialog";

import GlobalSearch from "./GlobalSearch";

const GlobalSearchAction = () => {
  const { t } = useTranslation("common");
  const [dialogOpen, setDialogOpen] = useState(false);
  const {
    pages,
    general: { topHeader },
  } = useConfigContext();

  useKeyBinding(["cmd", "k"], () => setDialogOpen(true));

  const searchTextPlaceholder =
    topHeader?.searchTextPlaceholder ||
    pages.topHeader?.searchTextPlaceholder ||
    t("global_search.placeholder");

  return (
    <>
      <div className="fixed left-1/2 top-3 transform -translate-x-1/2">
        <Button
          id="global-search"
          testId="global-search"
          onClick={() => setDialogOpen(true)}
          color="secondary"
          className="justify-start! flex flex-row max-w-[800px] w-[400px] min-w-[300]"
          startIcon={<SearchOutlinedIcon />}
        >
          <span className="mr-1 capitalize! whitespace-nowrap overflow-hidden text-ellipsis text-gray-500">
            {searchTextPlaceholder}
          </span>
          <span className="border border-gray-300 rounded-sm pl-1 pr-1 text-sm ml-auto flex flex-row items-center">
            <kbd
              className={classNames({
                "text-xs": !isMac,
                "text-sm": isMac,
              })}
            >
              {isMac ? "⌘" : "CTRL"}+
            </kbd>

            <kbd className="text-xs">K</kbd>
          </span>
        </Button>
      </div>
      <Dialog
        disableRestoreFocus
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth={true}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start",
            marginTop: "4rem",
          },
        }}
      >
        <GlobalSearch onClick={() => setDialogOpen(false)}></GlobalSearch>
      </Dialog>
    </>
  );
};

export default GlobalSearchAction;
